/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable max-len */
import React, { useState, useEffect } from "react";
import { Navigate, Route, Routes, useLocation, useParams } from "react-router-dom";

// import pages
import HomePage from "../home_page/home";
import AboutPage from "../about_page/about";
import ContactPage from "../contact_page/contact";
import StoreOrderPage from "../store_page/order_page";
import StoreProductPage from "../store_page/product_page";
import { StorefrontPage } from "../../features/marketplace/storefront";
import CollectiblesPage from "../../features/collectibles/CollectiblesPage";
import { StoreGate, StoreSwitchPage } from "../../features/storeSwitch";
import PrintFilesPage from "../../features/printFiles/PrintFilesPage";
import GalleryPage from "../gallery_page/gallery";
import LoginPage from "../authentication/login";
import SignupPage from "../authentication/signup";
import ErrorPage from "../error_page/error";
import AddArt from "../gallery_page/add_item";

import Header from "../site_header/site_header";
import MobileTopLogo from "../site_header/MobileTopLogo";

// import checkIsAuthenticated utility function
import ProfilePage from "../profile_page/profilePage";
// @deprecated — old chat removed, replaced by AgentChatWidget
// import ChatBot from "../chat/chat";
// import ChatBubble from "../chat/chatBubble";
import UsersStats from "../stats_page/userStats";
import InviteStatsPage from "../stats_page/inviteStatsPage";
import AiConfigAdminPage from "../stats_page/AiConfigAdminPage";
import { ArtOfTheDayPage } from "../../features/aotd";
import AOTD2025Favorite from "../art_of_the_day/aotd2025Favorite";
import TermsAndOwnership from "../art_of_the_day/TermsAndOwnership";
import AotdIrlEpdPreview from "../art_of_the_day/AotdIrlEpdPreview";
import AotdIrlClaim from "../art_of_the_day/AotdIrlClaim";
import AotdIrlLanding from "../art_of_the_day/AotdIrlLanding";
import AotdIrlSetup from "../art_of_the_day/AotdIrlSetup";
import AotdIrlDevices from "../art_of_the_day/AotdIrlDevices";
import AotdIrlAdminDashboard from "../art_of_the_day/AotdIrlAdminDashboard";
import AotdIrlAdminProvision from "../art_of_the_day/AotdIrlAdminProvision";
import AotdIrlAdminDevicesList from "../art_of_the_day/AotdIrlAdminDevicesList";
import AotdIrlAdminDeviceDetail from "../art_of_the_day/AotdIrlAdminDeviceDetail";
import AotdIrlAdminFirmware from "../art_of_the_day/AotdIrlAdminFirmware";
import AotdIrlAdminDisplayTemplates from "../art_of_the_day/AotdIrlAdminDisplayTemplates";
import AotdIrlAdminEditor from "../art_of_the_day/AotdIrlAdminEditor";
import AotdIrlMyFrames from "../art_of_the_day/AotdIrlMyFrames";
import AotdIrlMyFrameDetail from "../art_of_the_day/AotdIrlMyFrameDetail";
import ArtGrid from "../aotd-gallery/ArtGrid";
import ImageStreamDemo from "../image_stream/ImageStreamDemo";
import BirthdayEva from "../eva-birthday/eva";
import QRNotes from "../qRNotes/qRNotesPage";
import RecipePage from "../recipe_page/recipe_page";
import ResetPasswordPage from "../authentication/resetPassword";
import ForgotPasswordPage from "../authentication/forgotPassword";
// new auth service pages
import SessionsPage from "../authentication/SessionsPage";
import MfaSetupPage from "../authentication/MfaSetupPage";
import OAuthConsentPage from "../authentication/OAuthConsentPage";
import OAuthCallback from "../authentication/OAuthCallback";
import PartyInvite from "../random/partyInvite";
import UnsubPage from "../random/unsubPage";
import Footer from "../site_footer/site_footer";
import StatusFooter from "../status_bar/StatusFooter";
import BadgeAdminPage from "../badges/badges_admin/badgeAdminPage";
import { BadgeCollectionPage, MemberBadgesPage } from "../../features/badges/collection";
import { BadgeSharePage } from "../../features/badges/share";
import { WelcomePage } from "../../features/welcome";
import { GamePage } from "../../features/game";
import GameAdminPage from "../../features/game/admin/GameAdminPage";
import BadgeLab from "../../features/badges/BadgeLab";
import CardsAdminPage from "../../features/respectCards/admin/CardsAdminPage";
import EmojisAdminPage from "../../features/emojis/admin/EmojisAdminPage";
import CardEngineChat from "../card_engine/CardEngineChat";
import CardsPage from "../../features/respectCards/pages/CardsPage";
import DropLobbyPage from "../../features/respectCards/pages/DropLobbyPage";
import IconsPage from "../icons/iconsPage";
import CoffeePage from "../coffee_card_web/coffeePage";
import CoffeeAdmin from "../coffee_card_web/CoffeeAdmin";
import { CoffeeShopsPage, CoffeeShopDetailPage } from "../coffee_shops";
import ClusterAdminPage from "../coffee_clusters/ClusterAdminPage";
import ChainAdminPage from "../coffee_chains/ChainAdminPage";
import ChainPublicPage from "../coffee_chains/ChainPublicPage";
import MachineManager from "../coffee_machines/MachineManager";
import CoffeeMasterRequestsAdmin from "../coffee_machines/CoffeeMasterRequestsAdmin";
import CoffeeBrandsAdmin from "../coffee_machines/CoffeeBrandsAdmin";
import PrivacyPage from "../privacy_policy/privacy_policy";
import CookiePolicyPage from "../legal/cookie_policy";
import TermsPage from "../legal/terms";
import AotdScanRedirect from "../../features/prints/AotdScanRedirect";
import TodayPrints from "../../features/prints/today/TodayPrints";
import ServicesAdmin from "../admin/ServicesAdmin";
import SchedulerAdmin from "../admin/SchedulerAdmin";
import EventsAdmin from "../admin/EventsAdmin";
import AgentInspectorAdmin from "../admin/AgentInspectorAdmin";
import NotificationsAdmin from "../admin/NotificationsAdmin";
import ContributorsAdmin from "../admin/ContributorsAdmin";
import ContributorReviewPage from "../admin/ContributorReviewPage";
import ContributePage from "../contribute/ContributePage";
import ContributionsAdminPage from "../admin/ContributionsAdminPage";
import AddArtistArtworkPage from "../../features/artistsGallery/AddArtistArtworkPage";
import EditArtistArtworkPage from "../../features/artistsGallery/EditArtistArtworkPage";
import ArtistPage from "../../features/artistsGallery/ArtistPage";
import ArtworkStandalonePage from "../../features/artistsGallery/ArtworkStandalonePage";
// import CoffeeRatingsPage from "../coffee_card_web/CoffeeRatingsPage.preview";
import CoffeeRatingsPage from "../coffee_card_web/coffeePage";
import StyleGuide from "../StyleGuide/StyleGuide";
import AgentChatPage from "../agent_chat/AgentChatPage";
import AgentGamePage from "../agent_game/AgentGamePage";
import AgentChatWidget from "../agent_chat/AgentChatWidget";
import BlogPage from "../blog/BlogPage";
import BlogArticlePage from "../blog/BlogArticlePage";
import BlogEditorPage from "../blog/BlogEditorPage";
import BlogManagePage from "../blog/BlogManagePage";
import BooksPage from "../blog/BooksPage";
import BookPage from "../blog/BookPage";
import BookEditorPage from "../blog/BookEditorPage";
import BooksManagePage from "../blog/BooksManagePage";
import GenesisPage from "../genesis/GenesisPage";
import { SitelinePage } from "../../features/siteline";
import AotdHistoryAdminPage from "../art_of_the_day/AotdHistoryAdminPage";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { SpecialButtonsProvider } from "../../ui/specialButtons/SpecialButtonsContext";
import { IS_BETA, RECAPTCHA_SITE_KEY } from "../../config/env";
import RequireAdminRoute from "../authentication/RequireAdminRoute";
import RequireWriterRoute from "../authentication/RequireWriterRoute";

function withAdminGuard(element) {
  return <RequireAdminRoute>{element}</RequireAdminRoute>;
}

// blog authoring — admin or the `writer` role
function withWriterGuard(element) {
  return <RequireWriterRoute>{element}</RequireWriterRoute>;
}

// The genesis guide, gated to the same pair while the Season Zero allocation is
// still being tuned. It goes public on launch day by dropping this wrapper.
function withGenesisGuard(element) {
  return <RequireWriterRoute fallback="/">{element}</RequireWriterRoute>;
}

// Redirect target for the admin-enrollment QR (scanned off an un-enrolled
// frame's e-paper). Takes the device id from the URL and bounces into the
// existing admin device detail page with ?enroll=1 so the page surfaces
// the approval button.
function AotdIrlAdminEnrollRedirect() {
  const { deviceId } = useParams();
  const safe = deviceId ? encodeURIComponent(deviceId) : "";
  return <Navigate replace to={`/aotd-irl/admin/devices/${safe}?enroll=1`} />;
}

// Legacy -> new path redirect that preserves optional :deviceId segment.
// Firmware and printed QRs still reference the long /art-of-the-day/irl/*
// paths; these redirects keep them alive while we migrate UI internals.
function LegacyAotdIrlRedirect({ to }) {
  const params = useParams();
  const suffix = params.deviceId ? `/${encodeURIComponent(params.deviceId)}` : "";
  return <Navigate replace to={`${to}${suffix}`} />;
}

// /artists/:username → /art/:username (contributor pages moved into the /art namespace)
function LegacyArtistsUsernameRedirect() {
  const { username } = useParams();
  const safe = username ? encodeURIComponent(username) : "";
  return <Navigate replace to={`/art/${safe}`} />;
}

// /artists/edit/:id → /art/edit/:id
function LegacyArtistsEditRedirect() {
  const { id } = useParams();
  const safe = id ? encodeURIComponent(id) : "";
  return <Navigate replace to={`/art/edit/${safe}`} />;
}

// define OnlyForAuthenticatedRoute component
// const OnlyForAuthenticatedRoute = ({component: Component, isAuthenticated, ...rest}) => (
//     <Route
//         {...rest}
//         render={(props) =>
//             (isAuthenticated ? <Component {...props} /> : <Redirect to="/" />)}
//     />
// );

// define OnlyForGuestRoute component
// const OnlyForGuestRoute = ({component: Component, isAuthenticated, ...rest}) => (
//     <Route
//         {...rest}
//         render={(props) =>
//             (isAuthenticated ? <Redirect to="/home" /> : <Component {...props} />)}
//     />
// );

// function RequireAuth({ children, redirectTo }) {
// 	let isAuthenticated = getAuth();
// 	return isAuthenticated ? children : <Navigate to={redirectTo} />;
// }

// define PublicRoute component
const PublicRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    element={<Component />}
  // render={(props) => <Component {...props} />}
  />
);

// helper function to get mobile page background color based on route
const getMobilePageBg = (pathname, isBeta) => {
  // exact matches first
  if (pathname === "/") {
    return isBeta ? "#9b96fd" : "#b7ffae";
  }
  if (pathname === "/contact") {
    return "#ffc69d";
  }
  if (pathname === "/about") {
    return "#c9a3ff";
  }
  if (pathname === "/privacy" || pathname === "/cookies") {
    return "#f8f9fa";
  }
  if (pathname === "/contribute") {
    return "#fff3b0";
  }
  if (pathname === "/art" || pathname.startsWith("/art/")) {
    return "#b286ff";
  }
  if (
    pathname === "/profile" ||
    pathname === "/admin" ||
    pathname.startsWith("/admin/") ||
    pathname === "/cards-admin"
  ) {
    return "#c9febe";
  }
  if (pathname === "/cards") {
    // Keep the mobile top-logo strip on the same colour as the cards page
    // background (.cards-deck-wrap), which switches on prefers-color-scheme.
    const prefersDark =
      typeof window !== "undefined" &&
      typeof window.matchMedia === "function" &&
      window.matchMedia("(prefers-color-scheme: dark)").matches;
    return prefersDark ? "#9b96fd" : "#b7ffae";
  }
  if (pathname === "/blog" || pathname.startsWith("/blog/") || pathname === "/genesis") {
    return "#f0f0f0";
  }
  if (pathname === "/cookbook" || pathname.startsWith("/cookbook/") ||
    pathname === "/marketplace" || pathname.startsWith("/marketplace/") || pathname === "/collectibles" || pathname === "/art-of-the-day" ||
    pathname.startsWith("/art-of-the-day/")) {
    return "#f0f0f0";
  }
  if (pathname === "/login") {
    return "#fdbe7c";
  }
  if (pathname === "/register") {
    return "#8be0f5";
  }
  if (pathname === "/party") {
    return "#b7ffae";
  }
  if (pathname === "/siteline") {
    return "#f8f7f2";
  }
  if (pathname === "/badges" || pathname.startsWith("/badges/")) {
    return "#f7f4e2";
  }
  if (pathname.startsWith("/badge/s/")) {
    return "#111111";
  }
  // fallback to transparent
  return "transparent";
};

function CustomRouter() {
  const location = useLocation();
  const [useLegacyLayout, setUseLegacyLayout] = useState(() => {
    const stored = localStorage.getItem("useLegacyLayout");
    return stored === "true";
  });
  const [isMobile, setIsMobile] = useState(false);

  const isBeta = IS_BETA;

  const pageBg = getMobilePageBg(location.pathname, isBeta);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 700);
    };
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  useEffect(() => {
    const handleStorageChange = () => {
      const stored = localStorage.getItem("useLegacyLayout");
      setUseLegacyLayout(stored === "true");
    };
    window.addEventListener("storage", handleStorageChange);
    // also listen for custom event in case it's changed in same window
    window.addEventListener("legacyLayoutChanged", handleStorageChange);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
      window.removeEventListener("legacyLayoutChanged", handleStorageChange);
    };
  }, []);

  // set global mobile page background and theme-color for modern mobile layout
  useEffect(() => {
    if (isMobile && !useLegacyLayout) {
      // set global CSS variable on document root
      document.documentElement.style.setProperty('--mobile-page-bg', pageBg);

      // update theme-color meta tag (browser UI tint)
      let themeColorMeta = document.querySelector('meta[name="theme-color"]');
      if (!themeColorMeta) {
        themeColorMeta = document.createElement('meta');
        themeColorMeta.setAttribute('name', 'theme-color');
        document.head.appendChild(themeColorMeta);
      }
      // use fallback for transparent backgrounds (some browsers don't handle transparent theme-color well)
      const themeColor = pageBg === 'transparent' ? '#ffffff' : pageBg;
      themeColorMeta.setAttribute('content', themeColor);
    } else {
      // cleanup: remove the CSS variable when not in modern mobile layout
      document.documentElement.style.removeProperty('--mobile-page-bg');
      // reset theme-color to default
      const themeColorMeta = document.querySelector('meta[name="theme-color"]');
      if (themeColorMeta) {
        themeColorMeta.setAttribute('content', '#000000');
      }
    }
  }, [isMobile, useLegacyLayout, pageBg]);

  // hide footer on mobile when not using legacy layout
  const showFooter = !isMobile || useLegacyLayout;

  // standalone artwork pages render chrome-less — they ship their own logo
  // band so they read as a permanent reference, not part of site navigation.
  const isStandaloneArtwork = location.pathname.startsWith("/artworks/");
  // the public badge share page is a 9:16 story that people screenshot: no chrome
  const isBadgeShare = location.pathname.startsWith("/badge/s/");
  const isChromeless = isStandaloneArtwork || isBadgeShare;

  return [
    <>
      <SpecialButtonsProvider>
        {!isChromeless && <Header />}
        {!isChromeless && <AgentChatWidget />}
        <div
          className={
            !useLegacyLayout && isMobile
              ? "mobile-content-spacer"
              : "desktop-content-spacer"
          }
          style={isMobile && !useLegacyLayout ? { "--mobile-page-bg": pageBg } : undefined}
        >
          <GoogleReCaptchaProvider reCaptchaKey={RECAPTCHA_SITE_KEY}>
            {!isChromeless && <MobileTopLogo />}
            <Routes>
              {/* public logo endpoint – /logo and /bolt-glow.png both serve the same asset */}
              <Route path="/logo" element={<Navigate to="/bolt-glow.png" replace />} />
              <Route path="/" element={<HomePage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/art" element={<GalleryPage />} />
              <Route path="/art/add" element={<AddArt />} />
              <Route path="/art/contribute" element={<AddArtistArtworkPage />} />
              <Route path="/art/edit/:id" element={<EditArtistArtworkPage />} />
              <Route path="/art/:username" element={<ArtistPage />} />
              {/* legacy /artists/* paths — keep working as redirects */}
              <Route path="/artists" element={<Navigate replace to="/art" />} />
              <Route path="/artists/add" element={<Navigate replace to="/art/contribute" />} />
              <Route path="/artists/edit/:id" element={<LegacyArtistsEditRedirect />} />
              <Route path="/artists/:username" element={<LegacyArtistsUsernameRedirect />} />
              <Route path="/artworks/:id" element={<ArtworkStandalonePage />} />
              <Route path="/marketplace" element={<StoreGate><StorefrontPage /></StoreGate>} />
              <Route path="/marketplace/order" element={<StoreOrderPage />} />
              <Route path="/marketplace/:productId" element={<StoreGate><StoreProductPage /></StoreGate>} />
              <Route path="/collectibles" element={<CollectiblesPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/cookies" element={<CookiePolicyPage />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/profile" element={<ProfilePage />} />
              <Route path="/contribute" element={<ContributePage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<SignupPage />} />
              {/* old /chat route redirects to agent chat */}
              <Route path="/chat" element={<Navigate to="/agent-chat" replace />} />
              <Route path="/admin" element={withAdminGuard(<UsersStats />)} />
              <Route path="/admin/invites" element={withAdminGuard(<InviteStatsPage />)} />
              <Route path="/admin/marketplace" element={withAdminGuard(<StoreSwitchPage />)} />
              <Route path="/admin/print-files" element={withAdminGuard(<PrintFilesPage />)} />
              <Route path="/admin/ai-config" element={withAdminGuard(<AiConfigAdminPage />)} />
              <Route path="/admin/contributors" element={withAdminGuard(<ContributorsAdmin />)} />
              <Route path="/admin/contributions" element={withAdminGuard(<ContributionsAdminPage />)} />
              <Route path="/admin/artworks/review" element={withAdminGuard(<ContributorReviewPage />)} />
              {/* legacy route — redirect to /admin */}
              <Route path="/user-stats" element={<Navigate to="/admin" replace />} />
              <Route path="/user-stats/*" element={<Navigate to="/admin" replace />} />
              <Route path="/labs/image-stream" element={<ImageStreamDemo />} />
              <Route path="/art-of-the-day" element={<ArtOfTheDayPage />} />
              <Route path="/art-of-the-day/gallery" element={<ArtGrid />} />
              <Route path="/art-of-the-day/2025-favorite" element={<AOTD2025Favorite />} />
              <Route path="/art-of-the-day/termsandownership" element={<TermsAndOwnership />} />
              <Route path="/art-of-the-day/today/prints" element={<TodayPrints />} />
              {/* printed QR codes: record the scan, then today's prints */}
              <Route path="/aotd/:number" element={<AotdScanRedirect />} />
              {/* AOTD-IRL — unified namespace. Backend /api/aotd-irl/* is
                  firmware-locked and stays as is. Legacy /art-of-the-day/irl/*
                  and /admin/aotd-irl/* paths below redirect here so printed QRs
                  and existing bookmarks keep working. */}
              <Route path="/aotd-irl" element={<AotdIrlLanding />} />
              <Route path="/aotd-irl/epd-preview" element={<AotdIrlEpdPreview />} />
              <Route path="/aotd-irl/claim" element={<AotdIrlClaim />} />
              <Route path="/aotd-irl/claim/:deviceId" element={<AotdIrlClaim />} />
              <Route path="/aotd-irl/buy" element={<Navigate replace to="/aotd-irl" />} />
              <Route path="/aotd-irl/setup" element={<AotdIrlSetup />} />
              <Route path="/aotd-irl/devices" element={<AotdIrlDevices />} />
              <Route path="/aotd-irl/my" element={<AotdIrlMyFrames />} />
              <Route path="/aotd-irl/my/:deviceId" element={<AotdIrlMyFrameDetail />} />
              <Route path="/aotd-irl/admin" element={withAdminGuard(<AotdIrlAdminDashboard />)} />
              <Route path="/aotd-irl/admin/devices" element={withAdminGuard(<AotdIrlAdminDevicesList />)} />
              <Route path="/aotd-irl/admin/devices/:deviceId" element={withAdminGuard(<AotdIrlAdminDeviceDetail />)} />
              <Route path="/aotd-irl/admin/devices/:deviceId/layout" element={withAdminGuard(<AotdIrlAdminEditor />)} />
              <Route path="/aotd-irl/admin/firmware" element={withAdminGuard(<AotdIrlAdminFirmware />)} />
              <Route
                path="/aotd-irl/admin/display-templates"
                element={withAdminGuard(<AotdIrlAdminDisplayTemplates />)}
              />
              <Route path="/aotd-irl/admin/provision" element={withAdminGuard(<AotdIrlAdminProvision />)} />
              <Route
                path="/aotd-irl/admin/enroll/:deviceId"
                element={<AotdIrlAdminEnrollRedirect />}
              />

              {/* Legacy path redirects — keep working so printed/embedded URLs
                  (n450s.com/art-of-the-day/irl on the firmware WiFi screen, and
                  stale bookmarks) still land on the right page. */}
              <Route path="/art-of-the-day/irl-preview" element={<Navigate replace to="/aotd-irl/epd-preview" />} />
              <Route path="/art-of-the-day/irl/claim" element={<Navigate replace to="/aotd-irl/claim" />} />
              <Route path="/art-of-the-day/irl/claim/:deviceId" element={<LegacyAotdIrlRedirect to="/aotd-irl/claim" />} />
              <Route path="/art-of-the-day/irl/buy" element={<Navigate replace to="/aotd-irl" />} />
              <Route path="/art-of-the-day/irl/setup" element={<Navigate replace to="/aotd-irl/setup" />} />
              <Route path="/art-of-the-day/irl/devices" element={<Navigate replace to="/aotd-irl/devices" />} />
              <Route path="/art-of-the-day/irl/my" element={<Navigate replace to="/aotd-irl/my" />} />
              <Route path="/art-of-the-day/irl/my/:deviceId" element={<LegacyAotdIrlRedirect to="/aotd-irl/my" />} />
              <Route path="/art-of-the-day/irl/admin/enroll/:deviceId" element={<AotdIrlAdminEnrollRedirect />} />
              <Route path="/admin/aotd-irl" element={<Navigate replace to="/aotd-irl/admin" />} />
              <Route path="/admin/aotd-irl/devices" element={<Navigate replace to="/aotd-irl/admin/devices" />} />
              <Route path="/admin/aotd-irl/devices/:deviceId" element={<LegacyAotdIrlRedirect to="/aotd-irl/admin/devices" />} />
              <Route path="/admin/aotd-irl/firmware" element={<Navigate replace to="/aotd-irl/admin/firmware" />} />
              <Route path="/admin/aotd-irl/provision" element={<Navigate replace to="/aotd-irl/admin/provision" />} />

              <Route path="/cookbook/:title" element={<RecipePage />} />
              <Route path="/cookbook" element={<RecipePage />} />

              <Route path="/reset-pw" element={<ResetPasswordPage />} />
              <Route path="/forgot-pw" element={<ForgotPasswordPage />} />

              {/* new auth service routes */}
              <Route path="/sessions" element={<SessionsPage />} />
              <Route path="/security" element={<MfaSetupPage />} />
              <Route path="/mfa-setup" element={<MfaSetupPage />} />
              <Route path="/oauth/consent" element={<OAuthConsentPage />} />
              <Route path="/auth/callback" element={<OAuthCallback />} />
              <Route path="/oauth/callback" element={<OAuthCallback />} />
              {/* first sign-in of a new account: emoji + birthday (features/welcome) */}
              <Route path="/welcome" element={<WelcomePage />} />

              <Route path="/vako/birthday/aaa/i-mikri-mou-eva" element={<BirthdayEva />} />

              <Route path="/qrnotes" element={<QRNotes />} />

              <Route path="/party" element={<PartyInvite />} />
              <Route path="/unsubscribe" element={<UnsubPage />} />

              <Route path="/badges-admin" element={withAdminGuard(<BadgeAdminPage />)} />
              <Route path="/badges-lab" element={withAdminGuard(<BadgeLab />)} />
              <Route path="/admin/cards" element={withAdminGuard(<CardsAdminPage />)} />
              <Route path="/admin/emojis" element={withAdminGuard(<EmojisAdminPage />)} />
              <Route
                path="/admin/card-engine"
                element={withAdminGuard(React.createElement(CardEngineChat))}
              />
              <Route path="/cards-admin" element={<Navigate to="/admin/cards" replace />} />
              <Route path="/cards/drop" element={<DropLobbyPage />} />
              <Route path="/cards" element={<CardsPage />} />
              <Route path="/badges" element={<BadgeCollectionPage />} />
              <Route path="/badges/u/:username" element={<MemberBadgesPage />} />
              {/* public: works logged out (the share link members post) */}
              <Route path="/badge/s/:shareId" element={<BadgeSharePage />} />

              <Route path="/icons-admin" element={withAdminGuard(<IconsPage />)} />

              <Route path="/coffee" element={<CoffeePage />} />

              <Route path="/coffee-rate" element={<CoffeeRatingsPage />} />

              <Route path="/coffee/machines" element={<MachineManager />} />

              <Route path="/coffeeshops" element={<CoffeeShopsPage />} />
              <Route path="/coffeeshops/:id" element={<CoffeeShopDetailPage />} />
              <Route path="/chains/:id" element={<ChainPublicPage />} />

              <Route path="/coffee-admin" element={withAdminGuard(<CoffeeAdmin />)} />

              <Route path="/admin/clusters" element={withAdminGuard(<ClusterAdminPage />)} />
              <Route path="/admin/chains" element={withAdminGuard(<ChainAdminPage />)} />
              <Route path="/admin/coffee-masters" element={withAdminGuard(<CoffeeMasterRequestsAdmin />)} />
              <Route path="/admin/coffee-brands" element={withAdminGuard(<CoffeeBrandsAdmin />)} />

              <Route path="/admin/services" element={withAdminGuard(<ServicesAdmin />)} />
              <Route path="/admin/scheduler" element={withAdminGuard(<SchedulerAdmin />)} />
              <Route path="/admin/events" element={withAdminGuard(<EventsAdmin />)} />
              <Route path="/admin/agent" element={withAdminGuard(<AgentInspectorAdmin />)} />
              <Route path="/admin/notifications" element={withAdminGuard(<NotificationsAdmin />)} />
              <Route path="/admin/game" element={withAdminGuard(<GameAdminPage />)} />

              <Route path="/genesis" element={withGenesisGuard(<GenesisPage />)} />

              <Route path="/siteline" element={<SitelinePage />} />
              <Route path="/admin/aotd/:date" element={withAdminGuard(<AotdHistoryAdminPage />)} />

              <Route path="/agent-chat" element={<AgentChatPage />} />
              <Route path="/agent-game" element={<AgentGamePage />} />
              <Route path="/game" element={<GamePage />} />

              <Route path="/blog" element={<BlogPage />} />
              {/* static segments outrank /blog/:slug in React Router v6 ranking */}
              <Route path="/blog/new" element={withWriterGuard(<BlogEditorPage />)} />
              <Route path="/blog/manage" element={withWriterGuard(<BlogManagePage />)} />
              <Route path="/blog/manage/books" element={withWriterGuard(<BooksManagePage />)} />
              <Route path="/blog/manage/books/:id" element={withWriterGuard(<BookEditorPage />)} />
              <Route path="/blog/manage/:id" element={withWriterGuard(<BlogEditorPage />)} />
              <Route path="/blog/books" element={<BooksPage />} />
              <Route path="/blog/books/new" element={withWriterGuard(<BookEditorPage />)} />
              <Route path="/blog/books/:slug" element={<BookPage />} />
              <Route path="/blog/:slug" element={<BlogArticlePage />} />

              <Route path="/styleguide" element={<StyleGuide />} />

              <Route path="*" element={<ErrorPage />} />
            </Routes>
          </GoogleReCaptchaProvider>
        </div>
        {!isChromeless && showFooter && <Footer />}
        {!isChromeless && <StatusFooter />}
      </SpecialButtonsProvider>
    </>,
  ];
}

export default CustomRouter;
